/**
 * TanStack Query hooks for `prestashop-integration-via-webhook`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	prestashopIntegrationViaWebhookQueryKeys,
	type CreatePrestashopIntegrationViaWebhookBody,
	type ListPrestashopIntegrationViaWebhookResponse,
	type PrestashopIntegrationViaWebhookRow,
} from "./api";

export function usePrestashopIntegrationViaWebhookList(): UseQueryResult<ListPrestashopIntegrationViaWebhookResponse, Error> {
	return useQuery({
		queryKey: prestashopIntegrationViaWebhookQueryKeys.list(),
		queryFn: list,
	});
}

export function usePrestashopIntegrationViaWebhookCreate(): UseMutationResult<PrestashopIntegrationViaWebhookRow, Error, CreatePrestashopIntegrationViaWebhookBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: prestashopIntegrationViaWebhookQueryKeys.all });
		},
	});
}

export function usePrestashopIntegrationViaWebhookDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: prestashopIntegrationViaWebhookQueryKeys.all });
		},
	});
}
